module.exports = __webpack_public_path__ + "static/media/4C.78b8df72.jpg";